import { render, staticRenderFns } from "./BusinessRelation.vue?vue&type=template&id=384533e0&scoped=true&"
import script from "./BusinessRelation.vue?vue&type=script&lang=js&"
export * from "./BusinessRelation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384533e0",
  null
  
)

export default component.exports